module.exports = __webpack_public_path__ + "img/guohui.7ef52166.png";